module.exports = __webpack_public_path__ + "media/exports/required/assets/img/images/metaread_logo-e841a0e966352a0dee094468dbac0fdd.png";